import { useState } from "react";
import { ArrowRightLeft } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const inputCls = "w-full px-3 py-2 border border-zinc-300 rounded-none text-sm focus:outline-none focus:ring-2 focus:ring-brand";

export const BranchTransferField = ({ form, setForm, locations, fromLocation }) => {
  const [confirming, setConfirming] = useState(false);
  const branches = locations.filter((l) => l.name !== fromLocation);
  const toggle = (checked) => {
    if (checked) setConfirming(true);
    else setForm({ ...form, branch_transfer: false, transfer_to: "" });
  };
  return (
    <div className={`border p-3 space-y-2 ${form.branch_transfer ? "border-violet-400 bg-violet-50" : "border-zinc-200"}`} data-testid="branch-transfer-field">
      <label className="flex items-center gap-2 text-sm font-bold text-zinc-900 cursor-pointer">
        <input type="checkbox" checked={form.branch_transfer} onChange={(e) => toggle(e.target.checked)} data-testid="hire-branch-transfer-checkbox" className="accent-brand w-4 h-4" />
        <ArrowRightLeft size={15} /> Branch transfer
        {form.branch_transfer && <span className="ml-auto text-xs font-bold text-violet-700" data-testid="hire-branch-transfer-cost">Hire cost: $0.00</span>}
      </label>
      {form.branch_transfer && (
        <select required value={form.transfer_to} onChange={(e) => setForm({ ...form, transfer_to: e.target.value, customer: e.target.value || form.customer })} data-testid="hire-transfer-to-select" className={inputCls}>
          <option value="">Receiving branch…</option>
          {branches.map((l) => <option key={l.id} value={l.name}>{l.name}</option>)}
        </select>
      )}
      <AlertDialog open={confirming} onOpenChange={setConfirming}>
        <AlertDialogContent className="rounded-none" data-testid="branch-transfer-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-heading text-xl font-black tracking-tighter">Mark as a branch transfer?</AlertDialogTitle>
            <AlertDialogDescription>
              This moves equipment between your own branches. The hire cost will be set to <strong>$0.00</strong> and it won't count as unbilled.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="rounded-none" data-testid="branch-transfer-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction className="rounded-none bg-brand hover:bg-brand-dark" data-testid="branch-transfer-confirm"
              onClick={() => setForm({ ...form, branch_transfer: true })}>
              Yes, branch transfer
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
